import { useState, useEffect, useRef } from 'react';
import styles from './index.module.sass';
import classnames from 'classnames/bind';
import { getBrowser } from 'model/device';
import iconShortcutHintIos from 'assets/shortcut-ios.svg';
import iconShortcutHintAndroid from 'assets/shortcut-android.svg';
import iconShortcutAdd from 'assets/shortcut-add.svg';
import { ReactComponent as IconClose } from 'assets/icon_close.svg';
import { getHasBeenLogin, saveHasBeenLogin } from 'service/local-data-provider';
const cx = classnames.bind(styles);

const ShortcutHint = () => {
  const isSafari = getBrowser() === 'Safari';
  const [directA2HS, setDirectA2HS] = useState();
  const [showHint, setShowHint] = useState(!getHasBeenLogin());
  let deferredPrompt = useRef();

  const closeHint = () => {
    setShowHint(false);
    saveHasBeenLogin();
  };

  useEffect(() => {
    const handler = e => {
      e.preventDefault();
      setDirectA2HS(true);
      deferredPrompt.current = e;
    };
    window.addEventListener('beforeinstallprompt', handler);
  }, []);

  const ShortcutDirect = () => {
    const shortcutHintClass = cx({
      show: showHint,
      'shortcut-hint': true,
      direct: true,
    });
    return (
      <div
        className={shortcutHintClass}
        onClick={e => {
          setShowHint(false);
          // Show the prompt
          deferredPrompt.current.prompt();
          // Wait for the user to respond to the prompt
          deferredPrompt.current.userChoice.then(choiceResult => {
            if (choiceResult.outcome === 'accepted') {
              console.log('User accepted the A2HS prompt');
            } else {
              console.log('User dismissed the A2HS prompt');
            }
            deferredPrompt = null;
          });
        }}
      >
        儲存網頁到手機主畫面，開啟更快速，跟 App 一樣方便。
        <div className={styles.button}>儲存</div>
        <IconClose />
      </div>
    );
  };

  const ShortcutManual = () => {
    const shortcutHintClass = cx({
      show: showHint,
      'shortcut-hint': true,
      ios: isSafari,
    });
    return (
      <div className={shortcutHintClass} onClick={closeHint}>
        <img src={iconShortcutAdd} alt="add" />
        <span>
          儲存網頁到手機主畫面，開啟更快速，點擊瀏覽器{' '}
          <img src={isSafari ? iconShortcutHintIos : iconShortcutHintAndroid} alt="shortcut-hint" />{' '}
          選擇「加到主畫面」。
        </span>
        <IconClose />
      </div>
    );
  };

  if (directA2HS) {
    return <ShortcutDirect />;
  } else {
    return <ShortcutManual />;
  }
};

export default ShortcutHint;
